import { combineReducers } from 'redux';
import { StoreState } from '../../types/ReduxMisc';
import { uiStateReducer } from './uiStateReducer';
import { tpaParamsReducer } from './tpaParamsReducer';

export const rootReducer = combineReducers<StoreState>({
  uiState: uiStateReducer,
  tpaParams: tpaParamsReducer,
});
